/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TiebreakerMethod } from './TiebreakerMethod';
import {
    TiebreakerMethodFromJSON,
    TiebreakerMethodFromJSONTyped,
    TiebreakerMethodToJSON,
    TiebreakerMethodToJSONTyped,
} from './TiebreakerMethod';

/**
 * 
 * @export
 * @interface TiebreakerConfig
 */
export interface TiebreakerConfig {
    /**
     * 
     * @type {Array<TiebreakerMethod>}
     * @memberof TiebreakerConfig
     */
    methods: Array<TiebreakerMethod>;
}

/**
 * Check if a given object implements the TiebreakerConfig interface.
 */
export function instanceOfTiebreakerConfig(value: object): value is TiebreakerConfig {
    if (!('methods' in value) || value['methods'] === undefined) return false;
    return true;
}

export function TiebreakerConfigFromJSON(json: any): TiebreakerConfig {
    return TiebreakerConfigFromJSONTyped(json, false);
}

export function TiebreakerConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TiebreakerConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'methods': ((json['methods'] as Array<any>).map(TiebreakerMethodFromJSON)),
    };
}

export function TiebreakerConfigToJSON(json: any): TiebreakerConfig {
    return TiebreakerConfigToJSONTyped(json, false);
}

export function TiebreakerConfigToJSONTyped(value?: TiebreakerConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'methods': ((value['methods'] as Array<any>).map(TiebreakerMethodToJSON)),
    };
}

